'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _PageLayout = require('./PageLayout');

var _PageLayout2 = _interopRequireDefault(_PageLayout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

exports["default"] = _PageLayout2["default"];
module.exports = exports['default'];